export default {
    monthly: 'รายเดือน',
    exportPDF: 'ดาวน์โหลด PDF',
    exportExcel: 'ดาวน์โหลด EXCEL',
    exportText: 'ดาวน์โหลด Text',
    selectAll: 'เลือกทั้งหมด'
}
